export default __webpack_public_path__ + "static/media/fevnus-team.e0d4d1ae.png";